/**
 * پنجره‌ی کوچکِ «یک تصمیم، یک دلیل».
 *
 * تنها تکه‌ای از ابزارِ بازبینی که واقعاً چندبار لازم می‌شود، پس همین یکی جدا
 * شد و بقیه در جای خودشان ماندند. کپیِ `Card`/`Btn`ِ سایت نیامد — نگاه کن به
 * توضیحِ بالای ReviewTab برای اینکه چرا.
 *
 * ⚠️ از `features/review/` به `ui/` منتقل شد وقتی سربرگِ منابع هم لازمش شد:
 * دو سربرگ که به هم import کنند، مرزِ «هر فیچر کارِ خودش» را از همان اولین
 * کامپوننتِ مشترک می‌شکند. جایش این‌جاست، نه در خانه‌ی یکی از دو مصرف‌کننده.
 */
import React from 'react';

export function Modal({ title, hint, wide, onClose, children }: {
  title: string;
  hint?: string;
  /**
   * پنجره‌ی پهن — برای وقتی که محتوا **کد** است نه یک تصمیم.
   *
   * ⚠️ پیش‌فرض باریک می‌ماند و این عمدی است: عرضِ ۴۲۰ پیکسل چیزی است که
   * یک دلیل و دو دکمه را خوانا نگه می‌دارد. تنها مصرف‌کننده‌ی `wide`
   * نمایشِ HTMLِ یک صفحه‌ی گرفته‌شده است، که در آن عرض اصلاً خوانده نمی‌شود.
   */
  wide?: boolean;
  onClose: () => void;
  children: React.ReactNode;
}) {
  return (
    // کلیکِ پس‌زمینه می‌بندد، ولی کلیکِ داخلِ کادر نباید بالا برود و ببنددش —
    // وگرنه هر بار که کسی متنِ دلیل را انتخاب می‌کند پنجره بسته می‌شود.
    <div className="modal-backdrop" onClick={onClose}>
      <div className={`modal card${wide ? ' wide' : ''}`}
        onClick={(e) => e.stopPropagation()}>
        <h3>{title}</h3>
        {hint ? <p className="dim">{hint}</p> : null}
        {children}
      </div>
    </div>
  );
}
